import { render, staticRenderFns } from "./Whiteboard.vue?vue&type=template&id=226fc172&"
import script from "./Whiteboard.vue?vue&type=script&lang=js&"
export * from "./Whiteboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports